const login = {
    launchModal: function (options) {
        import('./launchmodal.js').then(({default: launchModal}) => launchModal(options));
    },
    listenForAuthEvents: function () {
        document.addEventListener('click', e => {
            if (e.target.dataset.reauthorize || e.target.dataset.authorize) {
                e.preventDefault();
                import('./authentication').then(({default: authentication}) =>
                    authentication.handleAuthenticationCheckClick(e.target, $link => {
                        location.href = $link.href;
                    })
                );
            }
        });
    }
};

export default login;
